// ==================== SENSOR READINGS ====================

export const FETCH_SENSOR_READINGS = {
    REQUEST: 'FETCH_SENSOR_READINGS_REQUEST',
    SUCCESS: 'FETCH_SENSOR_READINGS_SUCCESS',
    FAILURE: 'FETCH_SENSOR_READINGS_FAILURE'
};

export const fetchSensorReadingsRequest = (batchId) => ({
    type: FETCH_SENSOR_READINGS.REQUEST,
    payload: { batchId }
});

export const fetchSensorReadingsSuccess = (data) => ({
    type: FETCH_SENSOR_READINGS.SUCCESS,
    payload: data
});

export const fetchSensorReadingsFailure = (error) => ({
    type: FETCH_SENSOR_READINGS.FAILURE,
    payload: error
});

export const FETCH_SENSOR_STATS = {
    REQUEST: 'FETCH_SENSOR_STATS_REQUEST',
    SUCCESS: 'FETCH_SENSOR_STATS_SUCCESS',
    FAILURE: 'FETCH_SENSOR_STATS_FAILURE'
};

export const fetchSensorStatsRequest = (batchId) => ({
    type: FETCH_SENSOR_STATS.REQUEST,
    payload: { batchId }
});

export const fetchSensorStatsSuccess = (data) => ({
    type: FETCH_SENSOR_STATS.SUCCESS,
    payload: data
});

export const fetchSensorStatsFailure = (error) => ({
    type: FETCH_SENSOR_STATS.FAILURE,
    payload: error
});

export const CLEAR_SENSOR_DATA = 'CLEAR_SENSOR_DATA';

export const clearSensorData = () => ({
    type: CLEAR_SENSOR_DATA
});
